import {Window as GouiWindow} from "@intermesh/goui";
import {ServerApi} from "../util/ServerApi.js";
import {PortalConfig} from "../config.js";

function log(description:string) {

		const p = {
			data: {
				type: 'error',
				description: description.toString(),
				userAgent: window.navigator.userAgent,
				moduleName: 'Frontend',
				createdAt: new Date()
			}
		};

		ServerApi.call('log/create',p, 'POST')
			.catch(function(error) {
				void GouiWindow.error("Could not log error message to server: " + description);
			})

}

export function registorWindow(win:Window) {

	if (PortalConfig.logClientErrors) {
		console.log("Client error logging is enabled");
		win.addEventListener("error", e => {
			let description = e.message;

			if (e.error?.stack) {
				description += '\n\n-- Stack: \n\n' + e.error.stack.split("\n").slice(0, 3).join("\n");
			}

			log(description);
		});
		win.addEventListener("unhandledrejection", e => {
			log(e.reason);
		});
	}
}

registorWindow(window);